import * as React from "react";

function SvgArrow(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 167.6 107.8" {...props}><path d="M116.8 106.6l50.8-52.7-50.9-52.7c-1.5-1.6-4.1-1.6-5.7-.1-1.6 1.5-1.6 4.1-.1 5.7l41.6 43.1H4c-2.2 0-4 1.7-4 3.9s1.7 4 3.9 4.1h148.7L111 101c-1.5 1.6-1.4 4.1.1 5.6 1.6 1.6 4.1 1.5 5.7 0z" /></svg>;
}

export default SvgArrow;